export const getFileSize = (size: number) => {
  const k = Math.floor(Math.log2(size) / 10);
  const rank = `${k > 0 ? "КМГТ"[k - 1] : ""}b`;
  const count = size / Math.pow(1024, k);

  return `${count.toFixed(2)} ${rank}`;
};
